import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FatDoctoC } from 'app/shared/interfaces/fat-docto-c';
import { LancamentoAnexoOnline } from 'app/shared/interfaces/lancamento-anexo-online';
import { PageResult } from 'app/shared/interfaces/page-result';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { LancamentoAnexoOnlineService } from 'app/shared/services/lancamento-anexo-online.service';
import { LayoutService } from 'app/shared/services/layout.service';
import * as FileSaver from 'file-saver';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { LancamentoAnexoUploadComponent } from '../lancamento-anexo-upload/lancamento-anexo-upload.component';

@Component({
  selector: 'app-lancamento-anexo-upload-list',
  templateUrl: './lancamento-anexo-upload-list.component.html',
  styleUrls: ['./lancamento-anexo-upload-list.component.scss']
})
export class LancamentoAnexoUploadListComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  pageObject$: BehaviorSubject<PageResult<LancamentoAnexoOnline>> = new BehaviorSubject<PageResult<LancamentoAnexoOnline>>(null);
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  view = 'comfy';
  page = 1;
  length = 0;
  pageSize = 10;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  public searchInput = '';
  searchEntry$: Subject<string> = new Subject<string>();
  lancamento: any;
  lancamentoId: number;

  private destroy$ = new Subject<void>();


  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoAnexoUploadListComponent>,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private anexoService: LancamentoAnexoOnlineService) {

  }

  ngOnInit(): void {
    this.lancamento = this.data.payload;  
    this.lancamentoId = this.data.payload.controle;
    // retorna primeira página da pesquisa.
    this.getPage(1, this.pageSize);
    // inicializa paginator com valores retoRnados pela API.
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
        } else {
        }
      });

    this.debounceTimeSearch();
  }

  /**
* Retorna a página requerida,
* @param page numero da página requisitada, primeira página é 1
* @param pageSize quantidade de itens a serem retornados
*/
  getPage(page: number, pageSize: number) {
    this.anexoService.getLancamentoAnexoOnlinePage(this.lancamentoId, page, pageSize, this.selectedOrdem
      , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
  }

  /**
  * Retorna a página da pesquisa,
  * @param search valor a ser pesquisada
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getSearchPage(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      this.anexoService.getLancamentoAnexoOnlinePageSearch(search, this.lancamentoId, page, pageSize, this.selectedOrdem
        , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
    }
  }


  /**
   *
   * @param event Captura evento de mudança em alguma configuração no paginator e recarrega a lista.
   */
  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    if (this.searchInput.length > 0) {
      this.getSearchPage(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPage(event.pageIndex + 1, event.pageSize);
    }
  }

  searchBy_UsingDebounce(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearch() {
    this.searchEntry$
      .pipe(debounceTime(500))
      .subscribe((s) => this.getSearchPage(s, 1, this.pageSize));
  }


   private download(anexo: LancamentoAnexoOnline) {
      this.loader.open();
      this.anexoService.getLancamentoAnexo(anexo.id, true).pipe(takeUntil(this.destroy$)).subscribe((response) => {
        const name = anexo?.cadArquivoOnline?.fileName ?? anexo?.cadArquivoOnline?.fileCode;
        const presignedUrl = response?.cadArquivoOnline?.presignedUrl;
        fetch(presignedUrl)
          .then(response => response.blob())
          .then(blob => {
            FileSaver.saveAs(blob, name);
            this.loader.close();
          })
          .catch(error => {
            console.error('Error downloading file:', error);
          });
      }, err => {
        this.loader.close();
        const response = JSON.parse(new TextDecoder().decode(err.error));
        this.snack.open(`ERRO:${response.status}!`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          title: 'ERRO AO BAIXAR ARQUIVO',
          message: response.status, error: true
        }).pipe(takeUntil(this.destroy$)).subscribe(doc => {
          console.log(doc);
        });
      });
    }
  

  private delete(anexo: LancamentoAnexoOnline) {
    this.confirmService.confirm({message: `Deletar ${anexo?.cadArquivoOnline?.fileName}?`})
    .subscribe(res => {
      if (res) {
        this.anexoService.delete(anexo.id).subscribe(r=>{
          this.getPage(1, this.pageSize);
          this.snack.open('Arquivo enviado p/ a lixeira!', 'OK', { duration: 4000 });
        }, err=>{
          this.confirmService.confirm({
            title: `ERRO AO EXCLUIR ARQUIVO[${anexo?.cadArquivoOnline?.fileName}]`,
            message: 'Erro, verifique!', error: true
          }).subscribe(doc => {
            console.log(doc);
          });
        })
      }
    });
  }

  private downloadPopUp(anexo: LancamentoAnexoOnline) {
    this.confirmService.confirm({ message: `Baixar arquivo ${anexo?.cadArquivoOnline?.fileName}` })
      .subscribe(res => {
        if (res) {
          this.download(anexo);
        }
      });

  }

  private viewSize() {
    if (this.view === 'comfy') {
      return 20;
    } else if (this.view === 'module') {
      return 30;
    }
    return 100;
  }

  openAnexoUploadPopUp(cad: any = {}) {
    let title = "Upload de arquivos: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoAnexoUploadComponent, {
      width: this.layout.isMobile ? '98%' : '80%',
      disableClose: true,
      data: { title: title + "[ " + (cad.controle??'') + " - " + (cad?.nome??'') + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        this.selectedDirect = "DESC";
        this.selectedOrdem = "NENHUM";
        this.getPage(1, this.pageSize);
        if (!res) {
          return;
        }
      })
  }

  close() {
    this.dialogRef.close();
  }


}
